import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RepeatOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"repeat_on"}/>
}
